import { EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'
import { FinanceSalesInvoiceSequenceEntityFragment } from 'generated/resources/graphql'

const SEPARATOR = ' → '

export function mapToSerialSequenceFragment(
  a: EntitySelectEntity
): FinanceSalesInvoiceSequenceEntityFragment {
  const [name = '', pattern = ''] = a.name.split(SEPARATOR)
  return {
    __typename: 'FinanceSalesInvoiceSequence',
    id: Number(a.id),
    name,
    humanReadablePreview: pattern,
    pattern,
    legalEntityId: 1,
    startFrom: 1,
  }
}

export function mapSerialSequences(
  serialSequences: FinanceSalesInvoiceSequenceEntityFragment[]
): EntitySelectEntity[] {
  return serialSequences.map((el) => ({
    id: el.id,
    name: el.name + SEPARATOR + el.humanReadablePreview,
    avatar: undefined,
    searchKey: [el.name, el.pattern, el.startFrom, el.lastGeneratedSerial],
  }))
}
